import { defineStore } from 'pinia';
import { useThingsboard } from '~/composables/useThingsboard';

export const useDeviceStore = defineStore('device',{
  state: () => ({
    devices: [] as Device[],
  }),
  actions: {
    async getDevices(): Promise<Device[]> {
      const devices = await useThingsboard().getDevices();
      this.devices = devices;
      return this.devices;
    },
    getDeviceName(): string {
      const randomNumber = Math.floor(1000 + Math.random() * 9000);
      return `PLOMBA-${randomNumber}`;
    },
    async addDevice(device: Device): Promise<Device> {
      const created = await useThingsboard().registerDevice(device);
      return created as Device;
    },
    async updateDeviceLocation(deviceId: string, location: string, latitude: number, longitude: number) {
      await useThingsboard().updateDeviceLocation(deviceId, location, latitude, longitude);
    },
  },
})